import _regeneratorRuntime from "/home/buziakpl/buziak-new/buziak-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import t, { Component as e } from "react";
import n from "prop-types";

function o(t, e, n, o, i, a, s) {
  try {
    var r = t[a](s),
        l = r.value;
  } catch (t) {
    return void n(t);
  }

  r.done ? e(l) : Promise.resolve(l).then(o, i);
}

function i(t) {
  return function () {
    var e = this,
        n = arguments;
    return new Promise(function (i, a) {
      var s = t.apply(e, n);

      function r(t) {
        o(s, i, a, r, l, "next", t);
      }

      function l(t) {
        o(s, i, a, r, l, "throw", t);
      }

      r(void 0);
    });
  };
}

function a(t, e) {
  for (var n = 0; n < e.length; n++) {
    var o = e[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
  }
}

function s(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}

function r() {
  return (r = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function l(t) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function c(t, e) {
  return (c = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function u(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

function d(t, e) {
  return !e || "object" != typeof e && "function" != typeof e ? u(t) : e;
}

function _(t) {
  var e = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }();

  return function () {
    var n,
        o = l(t);

    if (e) {
      var i = l(this).constructor;
      n = Reflect.construct(o, arguments, i);
    } else n = o.apply(this, arguments);

    return d(this, n);
  };
}

var p = "styles_Editext__button__6H8n_",
    f = "styles_Editext__input__1534X",
    v = "styles_Editext__main_container__2Y-IL",
    h = "styles_Editext__editing_container__3yvUv",
    y = "styles_Editext__view_container__2l2kB",
    b = "styles_Editext__buttons_container__1kphL",
    m = "styles_Editext__buttons_showButtonsOnHover__EUUD5",
    g = "styles_Editext__buttons_before_aligned__NnoWq",
    x = "styles_Editext__buttons_after_aligned__1nlcG",
    E = "styles_Editext__validation_message__3B-OU",
    w = "styles_Editext__cancel_button__259hb",
    C = "styles_Editext__edit_button__hthOZ",
    O = "styles_Editext__save_button__3WN6q",
    B = "styles_Editext__hide_default_icons__AV_7m",
    N = "styles_Editext__hint__2QU2S";

function k() {
  return Array.apply(void 0, arguments).filter(function (t) {
    return t;
  }).join(" ");
}

!function (t, e) {
  void 0 === e && (e = {});
  var n = e.insertAt;

  if (t && "undefined" != typeof document) {
    var o = document.head || document.getElementsByTagName("head")[0],
        i = document.createElement("style");
    i.type = "text/css", "top" === n && o.firstChild ? o.insertBefore(i, o.firstChild) : o.appendChild(i), i.styleSheet ? i.styleSheet.cssText = t : i.appendChild(document.createTextNode(t));
  }
}('.styles_Editext__button__6H8n_ {\n  border-radius: 1px;\n  outline: none;\n  padding: 0.6em;\n  min-width: 30px;\n  height: 100%;\n  border-color: rgb(216, 216, 216) rgb(209, 209, 209) rgb(186, 186, 186);\n  border-style: solid;\n  border-width: 1px;\n}\n\n.styles_Editext__button__6H8n_:hover {\n  cursor: pointer;\n  background-color: rgba(241, 241, 241, 1);\n}\n\n.styles_Editext__input__1534X {\n  width: 100%;\n  border: 1px solid rgb(212, 212, 212);\n  padding: 0.6em;\n  outline: none;\n}\n\n.styles_Editext__main_container__2Y-IL {\n  display: flex;\n  flex-direction: column;\n}\n\n.styles_Editext__editing_container__3yvUv {\n  display: flex;\n  flex: 1;\n  align-items: center;\n}\n\n.styles_Editext__view_container__2l2kB {\n  display: flex;\n  align-items: center;\n}\n\n.styles_Editext__buttons_container__1kphL {\n  display: flex;\n}\n\n.styles_Editext__buttons_showButtonsOnHover__EUUD5 .styles_Editext__buttons_container__1kphL {\n  visibility: hidden;\n}\n\n.styles_Editext__buttons_showButtonsOnHover__EUUD5:hover .styles_Editext__buttons_container__1kphL {\n  visibility: visible;\n}\n\n.styles_Editext__buttons_before_aligned__NnoWq {\n  margin-right: 5px;\n}\n\n.styles_Editext__buttons_after_aligned__1nlcG {\n  margin-left: 5px;\n}\n\n.styles_Editext__validation_message__3B-OU {\n  font-weight: 500;\n  color: crimson;\n  font-size: 0.7em;\n  margin-top: 3px;\n}\n\n.styles_Editext__cancel_button__259hb {\n  color: crimson;\n}\n\n.styles_Editext__cancel_button__259hb::before {\n  content: "\\2715";\n  margin: 3px;\n}\n\n.styles_Editext__edit_button__hthOZ {\n  color: #000;\n}\n\n.styles_Editext__edit_button__hthOZ::before {\n  content: "\\270E";\n  margin: 3px;\n}\n\n.styles_Editext__save_button__3WN6q {\n  color: darkgreen;\n  margin-right: 3px;\n}\n\n.styles_Editext__save_button__3WN6q::before {\n  content: "\\2713";\n  margin: 3px;\n}\n\n.styles_Editext__hide_default_icons__AV_7m::before {\n  content: none;\n  margin: 0;\n}\n\n.styles_Editext__hint__2QU2S {\n  font-weight: 500;\n  color: lightslategray;\n  font-size: 0.7em;\n  margin-top: 3px;\n  text-align: left;\n}\n');

var P = "view-container",
    D = "edit-container",
    S = "edit-button",
    F = "save-button",
    U = "cancel-button",
    I = "input",
    V = "hint",
    R = function (n) {
  !function (t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && c(t, e);
  }(j, e);

  var o,
      l,
      d,
      R = _(j);

  function j(e) {
    var n;
    return function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }(this, j), s(u(n = R.call(this, e)), "handleKeyDown", function (t) {
      var e = n.props,
          o = e.submitOnEnter,
          i = e.inputProps,
          a = e.cancelOnEscape,
          s = [13, "Enter"].some(function (e) {
        return t.keyCode === e || t.code === e;
      }),
          r = [27, "Escape", "Esc"].some(function (e) {
        return t.keyCode === e || t.code === e;
      });
      s && (o && n.handleSave(), t.preventDefault()), r && (a && n.handleCancel(), t.preventDefault()), i.onKeyDown && i.onKeyDown(t);
    }), s(u(n), "handleOnBlur", function (t) {
      var e = n.props,
          o = e.cancelOnUnfocus,
          i = e.submitOnUnfocus,
          a = e.inputProps,
          s = n.editingButtons.current.contains(t.relatedTarget);
      o && !s && n.handleCancel(), i && !s && !o && n.handleSave(), a.onBlur && a.onBlur(t);
    }), s(u(n), "handleViewFocus", function (t) {
      n.setState({
        viewFocused: !0
      });
      var e = n.props,
          o = e.startEditingOnFocus,
          i = e.viewProps;
      o && n.setState({
        editing: !0
      }), i.onFocus && i.onFocus(t);
    }), s(u(n), "handleKeyDownForView", function (t) {
      var e = [13, "Enter"].some(function (e) {
        return t.keyCode === e || t.code === e;
      }),
          o = n.props,
          i = o.startEditingOnEnter,
          a = o.viewProps,
          s = e && n.state.viewFocused && i;
      s && t.preventDefault(), s && n.setState({
        editing: !0
      }), a.onKeyDown && a.onKeyDown(t);
    }), s(u(n), "handleInputChange", function (t) {
      n.setState({
        valid: !0,
        value: t.target.value
      });
    }), s(u(n), "handleCancel", function () {
      n.setState({
        valid: !0,
        editing: !1,
        value: n.state.savedValue || n.props.value
      }, function () {
        return n.props.onCancel(n.state.value, n.props.inputProps);
      });
    }), s(u(n), "handleActivateEditMode", function () {
      n.setState({
        editing: !0
      }, function () {
        n.props.onEditingStart(n.state.value);
      });
    }), s(u(n), "handleSave", i(_regeneratorRuntime.mark(function t() {
      var e, o, i, a, s;
      return _regeneratorRuntime.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return e = n.props, o = e.onSave, i = e.validation, a = e.onValidationFail, s = e.inputProps, t.next = 3, i(n.state.value);

            case 3:
              if (t.sent) {
                t.next = 6;
                break;
              }

              return t.abrupt("return", n.setState({
                valid: !1
              }, function () {
                a && a(n.state.value);
              }));

            case 6:
              n.setState({
                editing: !1,
                savedValue: n.state.value
              }, function () {
                return o(n.state.savedValue, s);
              });

            case 7:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), s(u(n), "_renderEditingMode", function () {
      var e = n.props,
          o = e.saveButtonClassName,
          i = e.saveButtonContent,
          a = e.cancelButtonClassName,
          s = e.editContainerClassName,
          r = e.viewContainerClassName,
          l = e.cancelButtonContent,
          c = e.onValidationFail,
          u = e.validationMessage,
          d = e.hint,
          _ = e.hideIcons,
          f = e.buttonsAlign,
          v = n._renderInput(),
          y = k("".concat(p), "".concat(O), _ && "".concat(B)),
          m = o || y,
          C = k("".concat(p), "".concat(w), _ && "".concat(B)),
          P = a || C,
          S = h;

      s && (S = s), r && (S = r);
      var I = k(b, "before" === f && "".concat(g), "after" === f && "".concat(x));
      return t.createElement("div", null, t.createElement("div", {
        ref: n.editingContainer,
        className: S,
        editext: D
      }, "after" === f && v, t.createElement("div", {
        className: I,
        ref: n.editingButtons
      }, t.createElement("button", {
        ref: n.saveButton,
        editext: F,
        type: "button",
        className: m,
        onClick: n.handleSave
      }, i), t.createElement("button", {
        type: "button",
        editext: U,
        className: P,
        onClick: n.handleCancel
      }, l)), "before" === f && v), !n.state.valid && !c && t.createElement("div", {
        className: E
      }, u), d && t.createElement("div", {
        className: N,
        editext: V
      }, d));
    }), s(u(n), "_renderViewMode", function () {
      var e = n.props,
          o = e.viewProps,
          i = e.editButtonClassName,
          a = e.editButtonContent,
          s = e.viewContainerClassName,
          l = e.hideIcons,
          c = e.buttonsAlign,
          u = e.editOnViewClick,
          d = e.showButtonsOnHover,
          _ = k("".concat(p), "".concat(C), l && "".concat(B)),
          f = i || _,
          v = k(s || y, d && "".concat(m)),
          h = k(b, "before" === c && "".concat(g), "after" === c && "".concat(x)),
          E = u ? n.handleActivateEditMode : void 0;

      return t.createElement("div", {
        className: v,
        editext: P
      }, "after" === c && t.createElement("div", r({
        tabIndex: n.props.tabIndex
      }, o, {
        onKeyDown: n.handleKeyDownForView,
        onFocus: n.handleViewFocus,
        onClick: E,
        editext: "view"
      }), n.state.value), t.createElement("div", {
        className: h
      }, t.createElement("button", {
        type: "button",
        editext: S,
        className: f,
        onClick: n.handleActivateEditMode
      }, a)), "before" === c && t.createElement("div", r({
        tabIndex: n.props.tabIndex
      }, o, {
        onKeyDown: n.handleKeyDownForView,
        onFocus: n.handleViewFocus,
        onClick: E,
        editext: P
      }), n.state.value));
    }), n.state = {
      editing: e.editing,
      valid: !0,
      value: e.value || "",
      savedValue: "",
      viewFocused: !1
    }, n.saveButton = t.createRef(), n.input = t.createRef(), n.editingContainer = t.createRef(), n.editingButtons = t.createRef(), n;
  }

  return o = j, (l = [{
    key: "componentDidMount",
    value: function value() {
      this.checkPropsConsistency();
    }
  }, {
    key: "checkPropsConsistency",
    value: function value() {
      this.props.cancelOnUnfocus && this.props.submitOnUnfocus && console.warn("EdiText: Both `cancelOnUnfocus` and `submitOnUnfocus` are set to true. `submitOnUnfocus` is ignored in this case. Please remove one of these.");
    }
  }, {
    key: "componentDidUpdate",
    value: function value(t, e) {
      var n = {};
      void 0 !== this.props.value && t.value !== this.props.value && (n.value = this.props.value), void 0 !== t.editing && t.editing !== this.props.editing && (n.editing = this.props.editing), Object.keys(n).length > 0 && this.setState(n);
    }
  }, {
    key: "_renderInput",
    value: function value() {
      return "textarea" === this.props.type ? t.createElement("textarea", r({
        ref: this.input,
        className: f,
        editext: I,
        tabIndex: this.props.tabIndex
      }, this.props.inputProps, {
        onBlur: this.handleOnBlur,
        value: this.state.value,
        onChange: this.handleInputChange,
        autoFocus: this.state.editing
      })) : t.createElement("input", r({
        ref: this.input,
        className: f,
        editext: I,
        tabIndex: this.props.tabIndex
      }, this.props.inputProps, {
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleOnBlur,
        value: this.state.value,
        type: this.props.type,
        onChange: this.handleInputChange,
        autoFocus: this.state.editing
      }));
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.state.editing ? this._renderEditingMode() : this._renderViewMode(),
          n = this.props,
          o = n.mainContainerClassName,
          i = n.className,
          a = k(o || v, i);
      return t.createElement("div", {
        className: a
      }, e);
    }
  }]) && a(o.prototype, l), d && a(o, d), j;
}();

R.defaultProps = {
  value: "",
  type: "text",
  validationMessage: "Invalid Value",
  validation: function validation(t) {
    return !0;
  },
  onEditingStart: function onEditingStart(t) {
    return null;
  },
  onCancel: function onCancel(t) {
    return null;
  },
  inputProps: {
    onKeyDown: function onKeyDown(t) {},
    onBlur: function onBlur(t) {},
    onFocus: function onFocus(t) {}
  },
  viewProps: {
    onKeyDown: function onKeyDown(t) {},
    onFocus: function onFocus(t) {}
  },
  cancelButtonContent: "",
  saveButtonContent: "",
  editButtonContent: "",
  hideIcons: !1,
  buttonsAlign: "after",
  editing: !1
}, R.propTypes = {
  inputProps: n.object,
  viewProps: n.object,
  value: n.string.isRequired,
  hint: n.node,
  validationMessage: n.node,
  validation: n.func,
  onValidationFail: n.func,
  type: n.oneOf(["text", "textarea", "password", "email", "number", "date", "datetime-local", "time", "month", "url", "week", "tel"]).isRequired,
  onCancel: n.func,
  onSave: n.func.isRequired,
  onEditingStart: n.func,
  className: n.string,
  saveButtonClassName: n.string,
  editButtonClassName: n.string,
  cancelButtonClassName: n.string,
  mainContainerClassName: n.string,
  editContainerClassName: n.string,
  viewContainerClassName: n.string,
  cancelButtonContent: n.any,
  saveButtonContent: n.any,
  editButtonContent: n.any,
  hideIcons: n.bool,
  buttonsAlign: n.oneOf(["after", "before"]),
  editOnViewClick: n.bool,
  editing: n.bool,
  showButtonsOnHover: n.bool,
  submitOnEnter: n.bool,
  cancelOnEscape: n.bool,
  cancelOnUnfocus: n.bool,
  submitOnUnfocus: n.bool,
  tabIndex: n.any,
  startEditingOnFocus: n.bool,
  startEditingOnEnter: n.bool
};
export default R;